import { ValidationResultErrorMessage } from './validation-result-error-message.model';
import { ValidationResult } from './validation-result.model';
import { AdditionalField } from '../../models/additional-field.model';
import { Recipient } from '../../models/recipient.model';

export class OrderValidationResult extends ValidationResult {
    invalidCodes?: string[];
    newAfCodes?: AdditionalField[];
    invalidAfCodes?: string[];
    invalidRecipientCodes?: string[];
    newOrderAfCodes?: AdditionalField[];
    newRecipients?: Recipient[];
    invalidMatrixSampleCode?: string[];
    errorMessages?: ValidationResultErrorMessage[];
    constructor() {
        super();
        this.newRecipients = [];
        this.invalidAfCodes = [];
        this.invalidRecipientCodes = [];
        this.newOrderAfCodes = [];
        this.invalidCodes = [];
        this.newAfCodes = [];
        this.errorMessages = [];
        this.invalidMatrixSampleCode = [];
    }
}
